import { MeasurementToolsViewModel } from '../../measurement-points-admin/model/measurement-points.model';
import { CustomeEvaluationRangeVM } from '../../CustomEval/custom-eval.model';
import { ModelBaseObservations } from '../../setup-models/setup-models.model';
import { BogieShimRequestModel } from '../../../shared/components/bogie-shim/bogie-shim-model';

export class InterpretationOverviewModel {
  InspectionId: number = -1;
  InspectionDate: Date;
  InspectorName: string;
  Released = false;
  Equipment: EquipmentModel = new EquipmentModel();
  ReleasedQuoteId: number;
  hasTemperatureInspection: boolean;
  TempInspectionId: number;
  EvalCode: string;
  hasFrameConfigFlag: boolean;

  observationInfo: ModelBaseObservations[];
  hasCRoller: boolean;
  WorkOrder: string;
  AdditionalInspectors: AddiInspectorsOverviewModel[];
  newAddiInspector: string;
  ShowAdditionalInspectors: boolean;
}

export class AddiInspectorsOverviewModel {
  Id: number;
  InspectorName: string;
  InspectionAuto: number;
  IsDeleted: boolean = false;
  editing: boolean;
  originalName: string;
}

export class EquipmentModel {
  EquipmentId: number = -1;
  SMU = 0;
  LTD = 0;
  SerialNumber: string;
  UnitNumber: string;
  CustomerName: string;
  ForecastId: number;
  JobsiteName: string;
  Make: string;
  Model: string;
  Family: string;
  FamilyId: number;
  EquipmentPhoto: string;
  //   TravelledKms: boolean;
  // ForwardTravel: number;
  // ReverseTravel: number;
  TrackSagL: string;
  TrackSagPhotoL: string;
  TrackSagCommentL = '';
  TrackSagR: string;
  TrackSagPhotoR: number;
  TrackSagCommentR = '';
  DryJointsL: string;
  DryJointsCommentsOnLeft = '';
  DryJointsPhotoOnLeft: string;
  DryJointsR: string;
  DryJointsCommentsOnRight = '';
  DryJointsPhotoOnRight: string;
  CannonExtL: string;
  CannonExtPhotoL: string;
  CannonExtCommentL = '';
  CannonExtR: string;
  CannonExtPhotoR: string;
  CannonExtCommentR = '';
  ScallopL: string;
  ScallopCommentOnLeft = '';
  ScallopPhotoOnLeft: string;
  ScallopR: string;
  ScallopCommentOnRight = '';
  ScallopPhotoOnRight: string;
  ForwardTravelHrs: number;
  ReverseTravelHrs: number;
  ForwardTravelKM: number;
  ReverseTravelKM: number;
  JobSiteComment: string;
  InspectionComment: string;
  ImpactValue: number;
  AbrasiveValue: number;
  MoistureValue: number;
  PackingValue: number;



  IsIndicatorLeft: boolean;
  IsIndicatorRight: boolean;
  ToeOutFrameIncorrect: boolean;


  IndicatorLeftComment: string = '';
  IndicatorRightComment: string = '';
  EqualiserBarTypeComment: string = '';

  EqualiserBarTypeImage: string;
  IndicatorLeftImage: string;
  IndicatorRightImage: string;

  ThermalImagesL01: string;
  ThermalImagesL02: string;
  ThermalImagesL03: string;
  ThermalImagesL04: string;
  ThermalImagesL05: string;


  ThermalImagesR01: string;
  ThermalImagesR02: string;
  ThermalImagesR03: string;
  ThermalImagesR04: string;
  ThermalImagesR05: string;

  AdditionalUnitNo: string;

  LinkNoL: string;
  LinkNoCommentsOnLeft = '';
  LinkNoPhotoOnLeft: string;

  LinkNoR: string;
  LinkNoCommentsOnRight = '';
  LinkNoPhotoOnRight: string;
  ShowHideCRoller: boolean;
  showDistTravelledTracking: boolean;
  ShowPropelHrsPerc: boolean;
  PropelHrs: number;
  PropelPerc: number;
  WorstWornR: number;
  WorstWornL: number;
  SummaryNotesExists: boolean;
  WorstEvalR: string;
  WorstEvalL: string;
}
export class ThermalVM {
  Image: string;
  Id: number;
}
export class SystemModel {
  Id: number = -1;
  Side: Side;
  Type: UCSystemType = 0;
  SerialNumber: string;
  DateInstalled: Date;
  SmuAtInstall = 0;
  Components: ComponentModel[] = [];
  ShowUTequvelent: boolean = false;
  LifeLived: number;
  LifeLivedKm: number;
  TotalComponentPurchaseCost: number;
  TotalComponentRepairsCost: number;
  BudgetLife: number;
  BudgetDistance: number;
  CastFrame: number;
  ToeOutFrame: number;
  SystemCondition: string;
  SystemConditionColor: string;
  BogieShimLeft: BogieShimRequestModel;
  BogieShimRight: BogieShimRequestModel;
  ComponentPitch: number;
  SystemImages: SystemInspectionImagesM[] = [];
  SystemComment: string;
  ShowHideCRoller: boolean;
}
export class SystemInspectionImagesM
{
  Id:number;
   SystemId: number;
  ImageUrl: string;
  ImagePath: string;
}

export class ComponentModel {
  ComponentId: number;
  Brand: string;
  CompartId_Auto: number;
  InspectionDetailId: number;
  ComponentTypeImage: string;
  Name: string;
  Position: string;
  WornPercentage: number;
  Measurement: number;
  MeasurementType: MeasurementType;
  Tool: string;
  Cmu: number;
  RisidualLife100: number;
  RisidualLife120: number;
  PhotoThumbnail: string;
  PhotoId: number;
  Comment: string;
  IsChild: boolean;
  ComponentTypeId: number;
  SortOrder: number;
  MakeId: number;
  ToolId: number;
  Pos: number;
  PossibleTools: MeasurementToolsViewModel[];
  isExcludeC: boolean = false;
  EvalCode: string;
  hasUTTool: boolean;
  UTequvelent: number;
  ParentWornPercentage: number;
  ParentComponentId: number;
  Side: number;
  Active: boolean;
  RecommendationId: number;
  hasMultipleMeasurement: boolean;
  multipleMeasurements: MultipleMeasurementsVM[];

  IsFlagged: boolean;
  ActionTaken: boolean;
  RemovedFromActionTaken: boolean;
  FlaggedInfo: ComponentFlaggedVM;
  DOC: number;
  ResidualDOC100: number;
  ResidualDOC120: number;
  actionHistoryCount: number
  IsLeftSideFinalImage: boolean;
  IsRightSideFinalImage: boolean;
  NewComponent: string;
  EnableFrameConfiguration: boolean = false;
  EnableCannonType: boolean = false;
  ComponentImages: ComponentImages[] = [];
  EnableBogieShim: boolean = false;
  BudgetLife?: number;
  JobNumber?: string;
  AssetNumber?: string;
}

export class ComponentImages {
  Id!: number;
  InspectionId!: number;
  InspectionDetailId!: number;
  ComponentImageUrl!: string;
}

export class ComponentFlaggedVM {
  public Id: number;

  public ComponentId: number;
  public PartNo: string;
  public BushTurned: string;
  public AssetNo: string;
  public JobNo: string;
  public ShoeCleanerHoleId: number;
  public ShoeCleanerHole: string;
  public Description: string;
  public Mlink: string;
  public Brand: string;
  public InspectionDetailsId: number;
  public InspectionId: number;
  public CompTypeId: number;
  public Comment: string;
  public Pos: string;
  public ShoeSizesId: number;
  public CompartId: number;
  public MakeId: number;
  public OldComponent: string;
}

export class MultipleMeasurementsVM {
  public RowId: number;
  public Id: number;
  public InspectionId: number;
  public InspectionDetailId: number;
  public value: number;
}
export class SystemGraphModel {
  Id: number = -1;
  Side: Side;
  Type: UCSystemType = 0;
  SerialNumber: string;
  DateInstalled: Date;
  SmuAtInstall = 0;
  InspectionId = 0;
  InspectionSmu = 0;
  Components: ComponentGraphModel[] = [];
}

export class ComponentGraphModel {
  ComponentId: number;
  InspectionDetailId: number;
  ComponentTypeImage: string;
  Name: string;
  Position: string;
  WornPercentage: number;
  Cmu: number;
  RisidualLife100: number;
  RisidualLife120: number;
  SmuAtInstall: number;
  CmuAtInstall: number;
  Recommendations: RecommendationModel[];
  ComponentTypeId: number;
  IsChild: boolean;
  Pos: number;
}

export class QuoteOverviewModel {
  QuoteId: number = -1;
  RecommendationIds: number[] = [];
  Recommendations: RecommendationModel[] = [];
}

export enum UCSystemType {
  Unknown = 0,
  Chain = 1,
  Frame = 2
}

export class RecommendationModel {
  RecommendationId = 0;
  ComponentId = 0;
  ComponentName = '';
  Side = '';
  Position = '';
  RecommendationName = '';
  TotalCost = 0;
  PartsCost = 0;
  LabourCost = 0;
  MiscCost = 0;
  StartActionAtSmu = 0;
  CompleteActionBySmu = 0;
  SeverityId = 0;
  Severitycategory = "";
  Comment = '';
  ActionId = 0;
  QuoteId = 0;
  ActionDateString = "";
  ActionDate = null;
}

export class UpdateComponentPhotoModel {
  InspectionId: number;
  PhotoId: number;
  NewPhoto: string;
  InspectionDetailId: number;
  Title: string;
  UpdateEqPhoto: boolean;
  ScreenId: number;
}


export class AddComponentPhotoModel {
  InspectionId: number;
  InspectionDetailId: number;
  NewPhoto: string;
  ComponentModel: any;
}
export class AddWSREFrameComponentPhotoModel {
  WSREID: number;
  WSREMeasurementPointId: number;
  CompartMeasurementPointId: number;
  side: number;
  NewPhoto: string;
  PhotoId: number;
  Title: string;
  IsFinalMeasurementImg: boolean;
  ScreenId: number;
}

export class AddThermalPhotoModel {
  InspectionId: number;
  Side: number;
  NewPhoto: string;
  PhotoId: number
}

export class AddSMUPhotoModel {
  InspectionId: number;
  NewPhoto: string;
  PhotoId: number
}
export class AuditModel {
  UserName: string;
  UserEmail: string;
  Date: Date;
  EventDescription: string;
}

export enum Condition {
  TrackSagL,
  TrackSagR,
  CannonExtL,
  CannonExtR,
  DryJointsL,
  DryJointsR,
  ScallopL,
  ScallopR,
  ThermalL,
  ThermalR,
  LinkNoL,
  LinkNoR,
  SMUImageHour,
  EquipmentComment,
  EqualiserBarTypeComment,
  EqualiserBarTypeImage,
  IndicatorLeftComment,
  IndicatorRightComment,
  IndicatorLeftImage,
  IndicatorRightImage,
  IsIndicatorLeft,
  IsIndicatorRight,
  ToeOutFrameIncorrect
}



export enum ForwardAndReverseOptions {
  ForwardTravelKm,
  ReverseTravelKm,
  ForwardTravelHrs,
  ReverseTravelHrs,
}

export enum UnderFootConditions {
  Impacts,
  Abrasive,
  Moisture,
  Packing,
  IsIndicatorRight,
  IsIndicatorLeft,
  ToeOutFrameIncorrect,
  Straight,
  ToeOut,
  Tension_Indicator_Right,
  Tension_Indicator_Left
}

export class UpdateConditionPhotoModel {
  InspectionId: number;
  Condition: Condition;
  NewPhoto: string;
  EquipmentId: number;
}


export class UpdateInspectionReadingBasedOnMeasurementClassModel {
  InspectionId: number;
  Condition: Condition;
  Reading: number;
}

export class UpdateInspectionForwardAndReverseTravelModel {
  ForwardAndReverseOptions: ForwardAndReverseOptions;
  InspectionId: number;
  NewReading: number;
  uod: string;
}

export class UpdateConditionCommentModel {
  InspectionId: number;
  Condition: Condition;
  NewComment: string;
  EquipmentId: number;
}

export class RecommendationTypeModel {
  Id: number;
  Description: string;
}

export class SeverityTypeModel {
  Id: number;
  Severitycategory: string;
}

export class AddRecommendationModel {
  InspectionId: number;
  ComponentId: number;
  QuoteId: number;
  ActionId: number;
  LabourCost: number;
  PartsCost: number;
  MiscCost: number;
  SmuToTakeAction: number;
  SmuToCompleteActionBy: number;
  Comment: string;
  AddedForBothSide: boolean;
  ActionDate: Date;
  SeverityId: number;
  BudgetDistance: number;
  Doc: number;
  CMU: number;
  BudgetLife: number;
  AvailableReplacementId: number;
  BrandId: number;
}

export class UpdateRecommendationModel {
  RecommendationId: number;
  InspectionId: number;
  ComponentId: number;
  QuoteId: number;
  ActionId: number;
  LabourCost: number;
  PartsCost: number;
  MiscCost: number;
  SmuToTakeAction: number;
  SmuToCompleteActionBy: number;
  Comment: string;
  ActionDate: Date;
  severityId: number
}

export enum BarGraphView {
  Expanded,
  Compact
}

export class Recipient {
  // constructor(email: string) {
  //   this.Email = email;
  //   this.Name = 'NEW';
  //   this.UserId = -1;
  // }
  DecryptedEmail:string
  UserId: number;
  Name: string;
  Email: string;
  DecryptedName:string;
}

export enum Side {
  Unknown = 0,
  Left = 1,
  Right = 2,
  Both = 3
}

export enum MeasurementType {
  Milimeter = 1,
  Inch = 2
}

export class SendQuoteReportVM {
  public quoteId: number;
  public inspectionId: number;
  public emailList: string[];
  public customernames: string[];
}

export class AvailableInspectorsViewModel {
  public UserId: number;
  public UserName: string;
}

export class UpdateComponentMeasurementModel {
  constructor(inspectionId: number, inspectionDetailId: number, measurement: number, measurementType: MeasurementType, toolId: number, evalRange: CustomeEvaluationRangeVM, screenId: number) {
    this.InspectionId = inspectionId;
    this.InspectionDetailId = inspectionDetailId;
    this.Measurement = measurement;
    this.MeasurementType = measurementType;
    this.ToolId = toolId;
    this.EvalautionRange = evalRange;
    this.ScreenId = screenId;
  }
  InspectionId: number;
  InspectionDetailId: number;
  Measurement: number;
  MeasurementType: MeasurementType = MeasurementType.Milimeter;
  ToolId: number;
  EvalautionRange: CustomeEvaluationRangeVM
  ScreenId: number;
  ToolType: number;
}

export class UpdateComponenMultipletMeasurementModel {
  constructor(id: number, inspectionId: number, inspectionDetailId: number, measurement: number, componentTypeId: number, uom: MeasurementType, evalautionRange: CustomeEvaluationRangeVM, toolId: number) {
    this.Id = id;
    this.InspectionId = inspectionId;
    this.InspectionDetailId = inspectionDetailId;
    this.Measurement = measurement;
    this.ComponentTypeId = componentTypeId;
    this.UOM = uom;
    this.EvalautionRange = evalautionRange;
    this.ToolId = toolId;
  }
  Id: number;
  InspectionId: number;
  InspectionDetailId: number;
  Measurement: number;
  ComponentTypeId: number;
  UOM: MeasurementType;
  EvalautionRange: CustomeEvaluationRangeVM;
  ToolId: number;
}

export class UpdateInspectionCommentModel {
  InspectionId: number;
  NewComment: string;
}

export class UpdateUnderFootConditionModel {
  InspectionId: number;
  UnderFootConditionOptions: UnderFootConditions;
  Impact: number;
  Abrasive: number;
  Moisture: number;
  Packing: number;
  ToeOutFrameIncorrect: boolean;
  IsIndicatorLeft: boolean;
  IsIndicatorRight: boolean;

}

export class UpdateFlag {
  inspectionId: number;
  selected_inspection_detail_auto: number;

  selected_track_unit_auto: number;
}

export class ComponentImageListVm {
  photo1: string;
  photo1_name: string;

  photo2: string;
  photo2_name: string;

  photo3: string;
  photo3_name: string;

  photo4: string;
  photo4_name: string;

  photo5: string;
  photo5_name: string;

  photoId1: number;

  photoId2: number;

  photoId3: number;

  photoId4: number;

  photoId5: number;
  photoId6: number;
  photoId7: number;
  IsFinalMeasurmentImage: boolean;

}

export class Implement {
  public ImplementID: number
  public ImplementName: string
}

export class ImplementSerialVM {
  public ImplementID: number
  public Implementserial: string
  public get_auto: number
}


export class RentInterpVM {
  public Worn: number
  public Calc: number
  public Input: number
  public Measure: number

}

export class GETImplementVM {
  public ImplementID: number
  public InspectionDate: Date
  public MeterReding: number
  public equipmentid_auto: number
  public flag: boolean
  public eval: number
  public ltd: number
  public InspectionID: number

}

export class GETImplementReport {
  public Id: number
  public EquipmentID: number
  public ImplementID: number
  public ONHireDate: Date
  public OFFHireDate: Date
  public SMUoN: number
  public SMUOff: number
  public ComponentType: string
  public ComponentId: number
  public ComponentName: string
  public ComponentTypeId: number
  public ObservationTypeId: number
  public ObservationId: number
  public ObservationName: string
  public WornPercentageOn: number
  public WornPercentageOff: number
  public WornPercentageDiff: number
  public cost: number
  public chargedCostValue: number
  public totalCost: number
  public comment: string
  public ReportName: string
  public ONInspectionId: number
  public OFFInspectionId: number
  public Attachment: string
  public Image: string;
}

export class UndercarriageImplementReport {
  public ONHireDate: Date
  public OFFHireDate: Date
  public SMUoN: number
  public SMUOff: number
  public componentName: string
  public leftWornPercentageON: number
  public leftWornPercentageOFF: number
  public rightWornPercentageON: number
  public roghtWornPercentageOFF: number
  public partNUmber: number
  public leftPctUsed: number
  public rightPctUsed: number
  public originalCosts: number
  public leftCost: number
  public rightCost: number
  public totalCost: number
  public comment: string
  public ReportName: string
  public ONInspectionId: number
  public OFFInspectionId: number
  public CompartId: number
  public EquipmentID: number
  public inspection_auto: number
  public Attachment: string
  public Image: string;

  public leftMeasurementON: number
  public leftMeasurementOFF: number
  public rightMeasurementON: number
  public roghtMeasurementOFF: number

  public leftMeasureUsed: number
  public rightMeasureUsed: number
}
export class TRACK_FORECAST {
  public Inspection_Auto: number;
  public Daily_Usage_Hours: number = 0;
  public Daily_Usage_Distance: number = 0;
  public Method: string;
  public PM_1_Date: Date;
  public PM1_SMU: number;
  public PM1_DOE: number;
  public PM_2_Date: Date;
  public PM2_SMU: number;
  public PM2_DOE: number;
  public Floating_Date: Date;
  public Floating_SMU: number;
  public Floating_DOE: number;
  public CreatedDate: Date;
  public CreatedUserId: number;
  public ModifiedDate: Date;
  public ModifiedUserId: number;
  public Forecast_Method: string;
  public Daily_Usage_Calculation_Method: string;

}
export class TRACKForcastVM {
  public InspectionId: number;
  public CurrentEquipmentUsageHours: number;

  public CurrentEquipmentUsageDistance: number;

  public ForecastMethod: string;

  public ForecastEntryHours: number;

  public ForecastEntryDistance: number;

  public LastInpectionDate: string = "";
  public LastInpectionDateOnly: Date;

  public LastinspectionSMU: number;

  public LastInspectionDistance: number;

  public PmNextDateService: Date;

  public PmNextDateServiceString: string;

  public PmNextDateServiceSMU: number;

  public PmNextDateServiceDOE: number;

  public SecondPmNextDateService: Date;

  public SecondPmNextDateServiceString: string;

  public SecondPmNextDateServiceSMU: number;

  public SecondPmNextDateServiceDOE: number;

  public FloatingDate: Date;

  public FloatingDateString: string;

  public FloatingSMU: number;

  public FloatingDOE: number;
  public FloatingDate2: Date;

  public FloatingDateString2: string;

  public FloatingSMU2: number;

  public FloatingDOE2: number;
  public DailyUsageHours: number;
  public DailyUageDistance: number;
  public DailyUsageCalculationMethod: string;
  public CreatedDate: Date;
  public CreatedUserId: number;
  public ActiveDays: number;

  public Show100Worn: boolean;
  public Show120Worn: boolean;
  public ShowLastFourth: boolean;
  public PmServiceFloatingDate2: number;
  public PmServiceFloatingDate1: number;
  public PmServiceSecondPmDate: number;
  public PmServiceNextPmDate: number;

  public PmNextServiceType: number;
  public PmSecondServiceType: number;
  public FloatingDate1ServiceType: number;
  public FloatingDate2ServiceType: number;
  public ForecastCalculationMethod: number;
  public WeatherTypeId: number;
  public SafetyFactor: number;
  public DistanceRatio: number;
   public MidpointPercentage: number;
}


export class AddRecommendationVM {
  equipmentId: number;
  DistanceReverse: number;
  DistanceForward: number;
  SMU: number;
  chainStatusM: ChainStatusModel[] = [];
  actionRecomendList: AddRecommendationModel[] = [];
  Flag: number;
  Comment: string;
}

export class ChainStatusModel {
  StatusId: number;
  SystemId: number
}

export class InspectionForecastPreferenceModel {
  TotalDistance: number = 0;
  Smu: number = 0;
  ActionTypeId: number = 0;
  EventDate: Date = new Date();
}

export class CopyInspection {
  InspectionId: number;
  EquipmentIdCopyTo: number;
  Flag: number;
}

export class CopyInspectionResponse {
  Data: ComponentComparison[] = [];
  Message: string;
  Status: number;
}

export class ComponentComparison {
  Component!: string;
  Side!: string;
  Position!: number;
  CompartType!: number;
  SourceCompartId!: number | null;
  SourceCompartName!: string;
  DestinationCompartId!: number | null;
  DestinationCompartName!: string;
}


export class ParentInspection {
  EquipmentId: number;
  SerialNo: string;
}

export class ParentInspectionResponse {
  Data: ParentInspection;
  Message: string;
  Status: number;
}

export class ActionRecommentDationOnDate {
  RowNum!: number;
  QuoteDetailAuto!: number;
  QuoteAuto!: number;
  TrackUnitAuto!: number;
  OpTypeAuto?: number;
  StartSmu?: number;
  EndSmu?: number;
  Price?: number;
  Comment?: string;
  LabourCost?: number;
  PartsCost?: number;
  MiscCost?: number;
  ComponentId?: number;
  EmailSent?: boolean;
  ActionDate?: Date;
  SeverityId?: number;
  StatusId?: number;
  BudgetDistance?: number;
  Doc?: number;
  Side: number;
  DistanceReverse: number;
  DistanceForward: number;
  ActionDescription: string;
  CommentOverall: string;
  AvailableReplacementId: number;
  BudgetLife: number;
  CMU: number;
  BrandId: number;
}

export class ActionRecommentDationOnDateVM {
  Data: ActionRecommentDationOnDate[] = [];
  Status: number;
  Message: string
}

export interface ComponentHistoryImages {
  TrackUnitId: number;
  InspectionId: number;
  InspectionDetailId: number;
  SMU: number;
  InspectionDate: string;  // Use string to represent ISO date (e.g., "2025-07-08T10:00:00Z")
  ImagePath: string;
  WornPercentage: number;
  Comment: string;
}
export interface ComponentImagesResponse {
  Data: ComponentHistoryImages[];
  Status: number;
  Message: string;
}

export interface GroupedImages {
  inspectionDate: string;
  smu: number;
  images: string[];
  wornpercentage: number;
  Comment: string;
}

export class ForecastConfigurationVM {
  CustomerId?: number;
  JobsiteId?: number;
  MakeId?: number;
  ModelId?: number;
  UnitNumber?: string;
  WearId?: number;
}

export class ForecastWearConfigurationViewModel {
  CustomerId!: number;      // f.customer_Auto AS CustomerId
  JobsiteId!: number;       // f.crsf_auto AS JobsiteId
  MakeId!: number;          // f.make_auto AS MakeId
  ModelId!: number;         // f.model_auto AS ModelIdC
  CustomerName!: string;    // c.cust_name AS CustomerName
  Make!: string;            // m.makedesc AS Make
  Jobsite!: string;         // j.site_name AS Jobsite
  ModelName!: string;
  UnitNumber: string;
  WearRateId: number = 0  // mo.modeldesc AS ModelName
}

export class ForecastWearConfigurationComponentViewModel {
  WearRateId!: number;
  CompartId!: number;
  CompartTypeID!: number;
  Position!: number;
}


export interface ForecastingComponentWearRateGroupViewModel {
  CompartTypeAuto: number;
  WearId: number;
  CompartType: string;
  Position: number;
  Comparts: CompartWeatherViewModel[];
}

export interface CompartWeatherViewModel {
  Compart: string;
  WeatherId: number;
  AvgCmu?: number | null;
  AvgDoc?: number | null;
}

export class UpdateAvgCmu {
  Id!: number;
  WearId!: number;
  Value!: number;
  Flag!: number;
}

export class InspectionMeasurement {
  CompartId!: number;
  InspectionDetailId!: number;
  UserId!: number;
  EquipmentId!: number;
  Measurement!: number;
  ToolId!: number;
  InspectionId!: number;
  Side!: number;
  Position!: number;
}
export class InspectionMeasurementVM {
  InspectionMeasurement: InspectionMeasurement[]
}

export interface UpdateTrackFrameConfigurationResponse {
  Status: boolean;
  Message: string;
  Data?: any;
}

export interface UpdateTrackFrameConfigurationRequest {
  WsreId: number;
  SelectedValue: boolean;
  Type: number;
  SystemInspectedSide: number;
}
export interface RecipientEmail {
  email: string;
  encryptedEmail: string;
}

export interface QuoteContactViewModel {
  ContactInformations: string[];
  QuoteAuto: number;
  UserAuto: number;
  SendQuote: boolean;
  UserNames: string[];
  SendTemperature: boolean;
  SendReportImmediately: boolean;
}

export class SystemInspectionImagesModel {
  InspectionId: number;
  SystemId: number;
  ImagePath: string;
  IsInspectionAddOrEdit: boolean;
}

export interface SystemInspectionImagesDetail {
  Id: number;
  ImagePath: string;
}

export interface SystemInspectionImagesVM {
  Data: SystemInspectionImagesDetail[];
  Status: number;
  Message: string;
}

